var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScanningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_402_132)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.9299 32.6074H15.0701V33.8907H8.39419V36.0001H27.6057V33.8907H20.9299V32.6074ZM28.5554 4.29468V11.8041C28.5554 14.4534 26.841 17.0376 23.4599 19.4851C21.1982 21.1223 18.9563 22.1331 18.862 22.1754L18 22.5612L17.138 22.1753C17.0438 22.133 14.8019 21.1222 12.5402 19.485C9.15905 17.0376 7.44462 14.4533 7.44462 11.8041V4.29468H0V24.9745H36V4.29468H28.5554ZM0 27.0838H36V30.5104H0V27.0838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.55469 0H16.946V7.63945H9.55469V0ZM19.0554 0H26.4467V7.63945H19.0554V0ZM26.4467 11.804V9.74883H19.0554V19.7274C21.3203 18.5361 26.4467 15.4382 26.4467 11.804ZM16.946 19.7274V9.74883H9.55469V11.804C9.55469 15.4382 14.681 18.5361 16.946 19.7274Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_402_132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanningIcon);
export default __webpack_public_path__ + "static/media/scanning_icon.47e94f5fbf8e3b3c565f9e72d90441b7.svg";
export { ForwardRef as ReactComponent };